import React, {useState} from 'react';
import Service from '../components/Service';
import { getServiceSummary } from '../../../data/booking/selectors/summary';
import PayButtonContainer from '../containers/PayButtonContainer';
import { formatCurrency } from '../../../data/shared/money';
import isEmpty from 'lodash/isEmpty';
import {withTranslation} from "react-i18next";
import {DRAFT, PENDING_QUOTATION} from "../../../data/booking/constants/quotation_status";
import Feed from "./history/Feed";
import {Advertisement} from "../../shared/components/Advertisement";

import SlideOver from "../../shared/components/SlideOver"
import { ChatBubbleOvalLeftEllipsisIcon } from "@heroicons/react/24/outline";


const Summary = ({ data, t }) => {
    const [slideOverOpen, setSlideOverOpen] = useState(false);
    
    return (
    <div className="mx-auto flex">
        <div className={"lg:w-9/12"}>
            <div className="flex-col-left recap-order rounded mt-2">
                <div className="px-10 py-2 ">
                    <div>
                        {data.services.map(service =>
                            <Service
                                key={service.id}
                                service={{
                                    ...service,
                                    summary: getServiceSummary(service),
                                    status: data.status,
                                    discount: data.pricing && data.pricing.discounts != null ? data.pricing.discounts.filter(function(discount){
                                        return discount.groupId == service.id;
                                    }) : null
                                }}
                            />
                        )}

                        {data.status != DRAFT && <section className="recap-item recap-total">
                            <div className="step-list">

                                <div className="total-resa">
                                    <div className="total-title">{t('followup.total_reservation')}</div>

                                    {data.status != PENDING_QUOTATION && data.pricing.discounts.map(function(discount, index){
                                        if(isEmpty(discount.groupId)) {
                                            return <div key={index} className="wb-line total-line">
                                                <div className="wb-cell main-cell">REMISE - {discount.label} :</div>
                                                <div className="wb-cell price">- {formatCurrency(discount.value)}</div>
                                            </div>
                                        }
                                        return null;
                                    })}

                                    {data.status != PENDING_QUOTATION && data.pricing.increases.map(function(increase, index){
                                        return <div key={index} className="wb-line total-line">
                                            <div className="wb-cell main-cell">MAJORATION - {increase.label} :</div>
                                            <div className="wb-cell price">+ {formatCurrency(increase.value)}</div>
                                        </div>
                                    })}

                                    {data.status != PENDING_QUOTATION && data.pricing.totalWithTaxes.amount > 0 &&
                                        <div className="wb-line total-line big-total">
                                            <div className="wb-cell main-cell !text-sm sm:!text-[16px]">{t('followup.ali_total')} :</div>
                                            <div className="wb-cell price">{formatCurrency(data.pricing.totalWithTaxes)}</div>
                                        </div>
                                    }

                                    {data.status != PENDING_QUOTATION && data.pricing.vats.map((vat, index) =>
                                        <div key={index} className="wb-line total-line total-ht">
                                            <div className="wb-cell main-cell">{t('followup.vat')} {vat.rate}% :</div>
                                            <div className="wb-cell price">{formatCurrency(vat.amount)}</div>
                                        </div>
                                    )}

                                    <div className="wb-line total-line total-ht">
                                        <div className="wb-cell main-cell">{t('followup.discounts')} :</div>
                                        <div className="wb-cell price">{formatCurrency(data.pricing.discountsTotal)}</div>
                                    </div>
                                </div>

                                {'reservation' == data.type &&
                                    <div className="payment">
                                        <div className="payment-title">{t('followup.balance')}</div>
                                        <div className="wb-line total-line">
                                            <div className="wb-cell main-cell">{t('followup.paid')} :</div>
                                            <div className="wb-cell price">{formatCurrency(data.pricing.totalPayments)}</div>
                                        </div>

                                        <div className="wb-line total-line">
                                            <div className="wb-cell main-cell">{t('followup.refunded')} :</div>
                                            <div className="wb-cell price">{formatCurrency(data.pricing.totalRefunds)}</div>
                                        </div>

                                        <div className="wb-line total-line big-total">
                                            <div className="wb-cell main-cell !text-xs sm:!text-[16px] !p-0">{t('followup.topaid')} :</div>
                                            <div className="wb-cell price">{formatCurrency(data.pricing.balance)}</div>
                                        </div>

                                        <br />
                                        {data.status != 'cancelled' && <PayButtonContainer />}
                                        <br />
                                    </div>
                                }
                            </div>
                        </section>}
                    </div>
                </div>
            </div>
            <Advertisement product={data.mainRoute.shopProduct} />

        </div>

        <div className='lg:hidden'>
            <SlideOver open={slideOverOpen} setOpen={setSlideOverOpen}>
                <div className="p-5">
                    <Feed />
                </div>
            </SlideOver>
            <ChatBubbleOvalLeftEllipsisIcon
                className="h-16 w-16 stroke-2 bg-[#F97316] p-2 text-white rounded-full fixed bottom-5 right-5 hover:cursor-pointer hover:bg-[#f2873d]"
                aria-hidden="true"
                onClick={() => {setSlideOverOpen(true)}}
            />
        </div>

        <div className="w-4/12 p-5 hidden lg:block">
            <Feed />
        </div>
    </div>
)}

export default withTranslation()(Summary);
